import { nextTick } from 'vue';

export function scrollToBottom(scrollableElement: HTMLElement, forced = false, behavior: ScrollBehavior = 'smooth', buffer = 80, delay = 50) {
  const isAtBottom = scrollableElement.scrollHeight - scrollableElement.scrollTop <= scrollableElement.clientHeight + buffer;

  if (isAtBottom || forced) {
    nextTick(() => {
      setTimeout(() => {
        scrollableElement.scrollTo({
          top: scrollableElement.scrollHeight,
          behavior: behavior
        });
      }, delay);
    });
  }
}

export function scrollTo(scrollableElement: HTMLElement, height: number, behavior: ScrollBehavior, delay = 50) {
  nextTick(() => {
    setTimeout(() => {
      scrollableElement.scrollTo({
        top: height,
        behavior: behavior
      });
    }, delay);
  });
}
